import { browserTracingIntegration, init, replayIntegration, sessionTimingIntegration, setUser } from '@sentry/browser';
const allowedLandscapes = ['dev', 'int'];
if (allowedLandscapes.includes(window.bifrostWeb.landscape)) {
    window.bifrostSentry = init({
        dsn: window.bifrostWeb.sentry.url,
        environment: window.bifrostWeb.landscape,
        integrations: [
            browserTracingIntegration(),
            replayIntegration({
                maskAllText: true,
                blockAllMedia: false,
                networkDetailAllowUrls: ['bf.cinemo.com'],
            }),
            sessionTimingIntegration(),
        ],
        beforeSend(event) {
            const isDev = Boolean(localStorage.getItem('devtools'));
            if (isDev) {
                return null;
            }
            return event;
        },
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
    });
}
export const identifyUser = () => {
    const id = window.bifrostAuth.accessTokenPayload?.sub;
    const email = window.bifrostAuth.accessTokenPayload?.email;
    const username = window.bifrostAuth.accessTokenPayload?.name;
    setUser({ id, email, username });
};
